import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
import Icon from '../Icon';
export const MediaPlayButton = ({ contrast }) => {
    return (_jsx("div", { className: twMerge('absolute left-1/2 top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 transition', 'group-hover:scale-125', 'group-focus-visible:scale-125', contrast === 'theme' && 'text-text-invert', contrast === 'image' && 'text-white'), children: _jsx(Icon, { variant: "play-circle", className: "aspect-square w-full" }) }));
};
